export default __webpack_public_path__ + "static/media/loading.28ae0930.gif";